import { createApi } from '@shared/redux/createApi';

const tags = {
  discountRates: 'discountRates',
  manualDiscountRates: 'manualDiscountRates',
  currentRates: 'currentRates'
};

export const discountRatesApi = createApi({
  reducerPath: 'discountRatesApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getCurrentDiscountRates: builder.query({
      query: () => ({
        url: '/discount/get-main',
        method: 'get'
      }),
      providesTags: [tags.currentRates],
      transformResponse: (response) => {
        return {
          buy: response.buy || null,
          sell: response.sell || null
        };
      }
    }),
    getAllDiscountRates: builder.query({
      query: (params) => {
        const { page, limit, ...rest } = params || {};
        return {
          url: '/discount/get-list',
          method: 'get',
          params: {
            page_number: page,
            page_size: limit,
            ...rest
          }
        };
      },
      providesTags: [tags.discountRates],
      transformResponse: (response) => {
        return {
          list: response.list || [],
          count: response.page_amount || 0
        };
      }
    }),
    getManualDiscountRates: builder.query({
      query: (params) => {
        // Convert page and limit to page_number and page_size
        const { page, limit, ...rest } = params || {};
        return {
          url: '/discount/get-manual-list',
          method: 'get',
          params: {
            page_number: page,
            page_size: limit,
            ...rest
          }
        };
      },
      providesTags: [tags.manualDiscountRates],
      transformResponse: (response) => {
        return {
          list: response.list || [],
          count: response.page_amount || 0
        };
      }
    }),
    setAllDiscountRate: builder.mutation({
      query: (data) => ({
        url: '/discount/set-all',
        method: 'post',
        body: data
      }),
      invalidatesTags: [tags.discountRates, tags.manualDiscountRates, tags.currentRates]
    }),
    setManualDiscountRate: builder.mutation({
      query: (data) => ({
        url: '/discount/set-manual',
        method: 'post',
        body: data
      }),
      invalidatesTags: [tags.discountRates, tags.manualDiscountRates, tags.currentRates]
    }),
    deleteDiscountRate: builder.mutation({
      query: (id) => ({
        url: '/discount/delete',
        method: 'post',
        body: { id }
      }),
      invalidatesTags: [tags.discountRates, tags.manualDiscountRates, tags.currentRates]
    })
  })
});

export const {
  useGetCurrentDiscountRatesQuery,
  useGetAllDiscountRatesQuery,
  useGetManualDiscountRatesQuery,
  useSetAllDiscountRateMutation,
  useSetManualDiscountRateMutation,
  useDeleteDiscountRateMutation
} = discountRatesApi; 